import routes from '@/routes/routes';
import Link from 'next/link';
import { useBlogCategoriesQuery } from '../blog.api';

export default function Header() {
  const { data: categories } = useBlogCategoriesQuery();
  return (
    <div className="flex flex-col gap-y-5 items-start justify-start overflow-x-auto">
      <Link href={routes.blog()}>
        <a>
          <div className="flex flex-row items-center gap-x-4 text-2xl font-bold">
            <img
              className="w-auto h-[36px] md:h-[50px]"
              src="/images/new-header-logo.svg"
              alt="logo"
            />
            <span>Secure Trade Club Blog</span>
          </div>
        </a>
      </Link>
      <div className="flex flex-row flex-1 border w-full bg-secondary text-white p-5 gap-x-6 rounded items-center">
        <Link href={routes.blog()}>
          <a>
            <span className="font-bold text-lg">Home</span>
          </a>
        </Link>
        {categories &&
          categories.map((category) => (
            <Link
              key={category.id}
              href={routes.blogCategory({ name: category.name, id: category.id })}
            >
              <a>
                <span>{category.name}</span>
              </a>
            </Link>
          ))}
      </div>
    </div>
  );
}
